export default "__VITE_ASSET__DNJ3r_iC__"